import React, { Component } from 'react';
import { langCheck } from 'Pub/js/utils';
import './slider.less';
export default class SliderModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            flag: false,
            title: langCheck('OwnLog-000011', 'pages', props.langJson), // 国际化处理：业务日志详细信息
            showHeader: true,
            showFooter: false,
            bodyInnerHTML: langCheck('OwnLog-000012', 'pages', props.langJson) //国际化处理：主体内容
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            flag: nextProps.flag
        });
    }

    toogleSideBox = () => {
        this.setState({ flag: !this.state.flag }, () => this.props.onChange(this.state.flag));
    };
    parseMsg = (node, isIe) => {
        let _this = this;
        var msg = ""
        if (node != null && node.childElementCount > 0) {
            if (node.childElementCount > 0 && node.childNodes[0].attributes == null) {
                return isIe ? ("由[" + node.childNodes[1].text + "]修改为[" + node.childNodes[0].text + "]") : ("由[" + node.childNodes[1].textContent + "]修改为[" + node.childNodes[0].textContent + "];&nbsp;&nbsp;&nbsp;&nbsp;");
            }
            for (var i = 0; i < node.childElementCount; i++) {
                var isButton = -1;
                var name = node.childNodes[i].getAttribute("displayname");
                var value = isIe ? node.childNodes[i].text : node.childNodes[i].textContent;
                if (name == null || value == null) {
                    var status = node.childNodes[i].getAttribute("status");
                    var statusContent = "<br />操作：[";
                    var Opername = "未知";
                    if (status == null) {
                        Opername = "";
                        isButton = 1;
                        statusContent = "由";
                    } else if (status == "1") {
                        Opername = "修改";
                    } else if (status == "2") {
                        Opername = "新增";
                    } else if (status == "3") {
                        Opername = "删除";
                    } else {
                        isButton = 1;
                        statusContent = "由";
                    }
                    //特殊规则
                    switch (isButton) {
                        case 1:
                            break;
                        case 2:
                            break;
                        default:
                            statusContent += Opername + "];&nbsp;&nbsp;&nbsp;&nbsp;";
                            break;
                    }
                    msg += statusContent;
                }

                if (node.childNodes[i].childElementCount > 0) {
                    msg += (node.childNodes[i].getAttribute("type") != null ? "<br /><br />" : "") + (name == null ? "" : (name + " : ")) + _this.parseMsg(node.childNodes[i], isIe);
                } else {
                    //特殊规则
                    if ((value != null && value != "")) {

                        if (name == null) {
                            name = "";
                        }
                        switch (isButton) {
                            case 1:
                                msg += name + "[ " + value + "]修改为[];&nbsp;&nbsp;&nbsp;&nbsp;"
                                break;
                            case 2:
                                msg += name + " [ " + value + "];&nbsp;&nbsp;&nbsp;&nbsp;"
                                break;
                            default:
                                msg += name + "：[ " + value + "];&nbsp;&nbsp;&nbsp;&nbsp;"
                                if (i == node.childElementCount - 1) {
                                    msg = msg + "<br />";
                                }
                                break;
                        }
                    }
                }


            }
            return msg;
        }
    }
    MyComponent = (content) => {
        let _this = this;
        return <div style={{ width: "100%" }} dangerouslySetInnerHTML={_this.createMarkup(content)} />;
    }

    createMarkup = (content) => {
        return { __html: content };
    }
    // 解析xml
    renderXML = (data) => {
        let parser = null,
            xmlStrDoc = null,
            msgContent = '',
            regTest = /xml/g;
        if (!regTest.test(data)) {
            msgContent = data;
        } else {
            if (window.DOMParser) {// Mozilla Explorer 
                parser = new DOMParser();
                xmlStrDoc = parser.parseFromString(data, "text/xml");
                const node = xmlStrDoc.getElementsByTagName("entity")[0];
                msgContent += this.parseMsg(node, false);
            } else {// Internet Explorer 
                xmlStrDoc = new ActiveXObject("Microsoft.XMLDOM");
                xmlStrDoc.async = "false";
                xmlStrDoc.loadXML(data);
                const node = xmlStrDoc.getElementsByTagName("entity")[0];
                msgContent += this.parseMsg(node, true);
            }
        }
        return this.MyComponent(msgContent);
    }
    render() {
        let { headerInnerHTML, footerInnerHTML, record } = this.props;
        let { flag, showHeader, showFooter, title } = this.state;
        let htmlArray = '';
        if (flag && record && record.logmsg && record.logmsg.value) {
            htmlArray = this.renderXML(record.logmsg.value);
        }

        return (
            <div className={`${flag ? 'side-box side-box-show' : 'side-box side-box-hide'}`}>
                <div className={`${flag ? 'side-box-content content-show' : 'side-box-content content-hide'}`}>
                    {showHeader && (
                        <header className='header'>
                            <span className='title'>{title}</span>
                            {headerInnerHTML}
                            <a href='javaScript:void(0)' onClick={this.toogleSideBox}>
                                {langCheck('OwnLog-000012', 'pages', this.props.langJson)}{/*国际化处理：主体内容*/}
                            </a>
                        </header>
                    )}
                    <div className='body'>
                        {flag &&
                            <div>
                                {htmlArray}
                            </div>
                        }
                    </div>
                    {showFooter && <footer className='footer'>{footerInnerHTML}</footer>}
                </div>
            </div>
        );
    }
}
// SliderModal.defaultProps = {
// 	title:langCheck("OwnLog-000011"),// '业务日志详细信息',
// 	showHeader: true,
// 	showFooter: false,
// 	bodyInnerHTML: langCheck("OwnLog-000011")//'主体内容'
// };
